import { useEffect, useMemo, useState } from 'react';

import { useAsyncIntervalDeprecated } from 'Hooks/useAsyncInterval';

import fr from 'facet-rest';

const MAX_ATTEMPTS = 10;
const RETRY_DELAY_IN_SECONDS = 2;


export default function useCIPInformationVerification(resource, setPageContentCollection, refreshCollection) {
  const [loading, setLoading] = useState(true);

  const cipStatusItems = useMemo(() => {
    if (!loading && resource?.attr('cipStatusItems')) {
      return resource.attr('cipStatusItems').resources().list();
    }
    return [];
  }, [loading]);

  const shouldRetry = resource.withRelationship(fr.relationships.retryLink.name,
    () => true,
    () => false);


  async function handleRetryStopped() {
    if (shouldRetry) {
      resource.link('self').removeSearchParam('noCache');
      const collection = await resource.link('self').get();
      setPageContentCollection(collection);
    }
    setLoading(false);
  }

  const {
    reset,
    resetRetryCount,
    setDelay,
    retryCount,
  } = useAsyncIntervalDeprecated(refreshCollection, 0, { onClearInterval: handleRetryStopped, maxRetry: MAX_ATTEMPTS });

  useEffect(() => {
    // on change on status, reset any existing retry mechanisms
    resetRetryCount();

    // are we in a state that does not require sync?
    if (!shouldRetry) {
      reset();
      setLoading(false);
    } else if (resource.link('self').param('noCache') === 'true') {
      setDelay(RETRY_DELAY_IN_SECONDS);
    } else {
      setLoading(false);
    }
  }, [resource.attr('status')]);

  return {
    loading,
    cipStatusItems,
    retryCount,
  };
}
